import React, {useState, useEffect} from 'react'
import {
  CheckboxColor,
  CheckboxUnit,
  Checkboxs,
  DBFilterCheckboxArea,
  DBFilterDateArea,
  DBFilterWrapper,
  DateArea,
  GotoStatus
} from './styles';
import {Checkbox, Input, ConfigProvider, DatePicker, Select} from 'antd';
import {useStatusList} from 'CRM/hooks/GetStatusList';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import locale from "antd/lib/locale/ko_KR";
import {Icon} from '../Main/styles';
import {IoSearch} from "react-icons/io5";
import {RangePickerProps} from 'rc-picker/es/RangePicker.d';
import {FaArrowRotateRight} from "react-icons/fa6";
import {useIsMobile} from "../../components/IsMobile";

const {RangePicker} = DatePicker;

export const CustomerFilter = ({
                                 pathList,
                                 resList,
                                 teamList,
                                 platformList,
                                 depositedAt,
                                 setDepositedAt,
                                 createdAt,
                                 setCreatedAt,
                                 assignedAt,
                                 setAssignedAt,
                                 updatedAt,
                                 setUpdatedAt,
                                 name,
                                 setName,
                                 tel,
                                 setTel,
                                 path,
                                 setPath,
                                 respon,
                                 setRespon,
                                 team,
                                 setTeam,
                                 platform,
                                 setPlatform,
                               }) => {
  const IsMobile = useIsMobile();
  useEffect(() => {
    setInputName(name)
    setInputTel(tel)
    setInputPath(path)
    setInputRes(respon)
    setInputTeam(team)
    setInputPlatform(platform)
    setInputDeposited([depositedAt?.[0], depositedAt?.[1]])
    setInputCreated([createdAt?.[0], createdAt?.[1]])
    setInputAssigned([assignedAt?.[0], assignedAt?.[1]])
    setInputUpdated([updatedAt?.[0], updatedAt?.[1]])
  }, [name, tel, path, respon, team, platform, depositedAt, createdAt, assignedAt, updatedAt])
  const [inputName, setInputName] = useState(name);
  const [inputTel, setInputTel] = useState(tel);
  const [inputPath, setInputPath] = useState(path);
  const [inputRes, setInputRes] = useState(respon);
  const [inputTeam, setInputTeam] = useState(team);
  const [inputPlatform, setInputPlatform] = useState(platform);
  const [inputDeposited, setInputDeposited] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputCreated, setInputCreated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputAssigned, setInputAssigned] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputUpdated, setInputUpdated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);


  const clickSearch = () => {
    const depositedStart = inputDeposited?.[0] ? dayjs(inputDeposited?.[0]) : null;
    const depositedEnd = inputDeposited?.[1] ? dayjs(inputDeposited?.[1]) : null;

    const createdStart = inputCreated?.[0] ? dayjs(inputCreated?.[0]) : null;
    const createdEnd = inputCreated?.[1] ? dayjs(inputCreated?.[1]) : null;

    const assignedStart = inputAssigned?.[0] ? dayjs(inputAssigned?.[0]) : null;
    const assignedEnd = inputAssigned?.[1] ? dayjs(inputAssigned?.[1]) : null;

    const updatedStart = inputUpdated?.[0] ? dayjs(inputUpdated?.[0]) : null;
    const updatedEnd = inputUpdated?.[1] ? dayjs(inputUpdated?.[1]) : null;

    setDepositedAt([depositedStart, depositedEnd]);
    setCreatedAt([createdStart, createdEnd]);
    setAssignedAt([assignedStart, assignedEnd]);
    setUpdatedAt([updatedStart, updatedEnd]);
    setName(inputName)
    setTel(inputTel)
    setPath(inputPath)
    setRespon(inputRes)
    setTeam(inputTeam)
    setPlatform(inputPlatform)
  }

  const clickReset = () => {
    setDepositedAt([null, null])
    setCreatedAt([null, null])
    setAssignedAt([null, null])
    setUpdatedAt([null, null])
    setName('')
    setTel('')
    setPath('')
    setRespon('')
    setTeam('')
    setPlatform('')
  }

  return (
    <>
      {IsMobile ?
        <DBFilterWrapper style={{marginBottom: 20}}>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>담당자</label>
              <Select value={inputRes} onChange={(e) => setInputRes(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {resList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>팀별</label>
              <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {teamList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>고객명</label>
              <Input type='text' id='name' value={inputName} onChange={(e) => setInputName(e.target.value)}
                     placeholder='고객명 검색 입력'/>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='tel'>연락처</label>
              <Input type='text' id='tel' value={inputTel} onChange={(e) => setInputTel(e.target.value)}
                     placeholder='연락처 검색 입력'/>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>방문경로</label>
              <Select value={inputPath} onChange={(e) => setInputPath(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {pathList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>플랫폼</label>
              <Select value={inputPlatform} onChange={(e) => setInputPlatform(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {platformList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch/></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight/></Icon>
              초기화
            </GotoStatus>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='depositedAt'>입금일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='depositedAt'
                  value={inputDeposited}
                  onChange={(values) => setInputDeposited(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>배정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputAssigned}
                  onChange={(values) => setInputAssigned(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
        </DBFilterWrapper>
        :
        <DBFilterWrapper>
          <DBFilterDateArea>
            <>
              <DateArea>
                <label htmlFor='name'>담당자</label>
                <Select value={inputRes} onChange={(e) => setInputRes(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {resList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>팀별</label>
                <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {teamList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>고객명</label>
                <Input type='text' id='name' value={inputName} onChange={(e) => setInputName(e.target.value)}
                       placeholder='고객명 검색 입력'/>
              </DateArea>
              <DateArea>
                <label htmlFor='tel'>연락처</label>
                <Input type='text' id='tel' value={inputTel} onChange={(e) => setInputTel(e.target.value)}
                       placeholder='연락처 검색 입력'/>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>방문경로</label>
                <Select value={inputPath} onChange={(e) => setInputPath(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {pathList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>플랫폼</label>
                <Select value={inputPlatform} onChange={(e) => setInputPlatform(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {platformList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
            </>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch/></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight/></Icon>
              초기화
            </GotoStatus>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='depositedAt'>입금일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='depositedAt'
                  value={inputDeposited}
                  onChange={(values) => setInputDeposited(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>배정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputAssigned}
                  onChange={(values) => setInputAssigned(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
        </DBFilterWrapper>
      }
    </>
  )
}

export default React.memo(CustomerFilter);